exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-344d9c8a]{padding:3rem 1.5rem}", ""]);

// exports
